import key from './key'
import close from './close'
import search from './search'
import link from './link'
import northEast from './north-east'

export default {
  keySVG: key,
  closeSVG: close,
  searchSVG: search,
  linkSVG: link,
  northEastSVG: northEast,
}
